/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UpgradeProcessInfoDTO = {
    /**
     * Can be one of: STARTED, PENDING, REJECTED
     */
    generalStatus?: UpgradeProcessInfoDTO.generalStatus;
    processId?: string;
    tierId?: number;
    tierName?: UpgradeProcessInfoDTO.tierName;
};

export namespace UpgradeProcessInfoDTO {

    /**
     * Can be one of: STARTED, PENDING, REJECTED
     */
    export enum generalStatus {
        STARTED = 'STARTED',
        PENDING = 'PENDING',
        APPROVED = 'APPROVED',
        REJECTED = 'REJECTED',
        DISCARDED = 'DISCARDED',
        BLOCKED = 'BLOCKED',
    }

    export enum tierName {
        BRONZE = 'BRONZE',
        SILVER = 'SILVER',
        GOLD = 'GOLD',
        PLATINUM = 'PLATINUM',
    }


}

